export * from './local-storage-key.constant';

export const DEVICE_TYPE = 'web';

export const DEFAULT_PAGE_INDEX = 1;
export const DEFAULT_PAGE_SIZE = 10;

export const DATE_FORMAT = 'MMM DD[,] YYYY';
